import axios from "axios";
import React, { forwardRef, useMemo, useState, useCallback, useImperativeHandle } from "react";

import Pagination, { SetPager } from "util/component/Pagination/v2";

import { dateToDateFormat,dateToDateFormat2 } from "util";

import { LoadingIndicatorBox } from "util/component/Loading";

const VIEW_BLOCK = 10;

const Table = (props, ref) => {
    const [loading, setLoading] = useState(false);

    const [dataList, setDataList] = useState({ data: [], pager: null });

    const [viewPage, setViewPage] = useState(20);

    useImperativeHandle(ref, () => ({
        getData,
    }));

    const getData = useCallback(
        async (data) => {
            setLoading(true);
            const { prev, next, ...body } = data;
            const prevTime = dateToDateFormat(prev);
            const nextTime = dateToDateFormat2(next);

            const response = await axios.post(process.env.REACT_APP_API + "/history/retrieveBplLog", {
                fromDate: prevTime,
                toDate: nextTime,
                ...body
            });
            const result = response.data.data.result;
            const pager = new SetPager(result.length, viewPage, VIEW_BLOCK);
            setDataList({ data: result, pager });
            setLoading(false);
        },
        [viewPage]
    );

    const renderDataList = useMemo(() => {
        const { data, pager } = dataList;
        if (!pager) return null;
        const range = pager.getItemRange();
        let indexNo = pager.getIndexNO();
        let render = [];

        for (let i = range.start; i < range.end; i++) {
            render.push(data[i]);
        }

        return render.map((rowData, index) => {
            indexNo--;
            return (
                <tr key={rowData.rownum + rowData.regDate}>
                    <td className={`text-center`}>{indexNo + 1}</td>
                    <td>{`${rowData.userNm}(${rowData.userId})`}</td>
                    <td>{rowData.methodNm}</td>
                    <td>{rowData.rtnMsg}</td>
                    <td>{rowData.regDate}</td>
                </tr>
            );
        });
    }, [dataList]);

    const viewPageChange = (e) => {
        setViewPage(e.target.value);
        setDataList((OLD) => {
            const { data, pager } = OLD;
            pager.setViewCnt(e.target.value);
            return { data, pager: pager };
        });
    };

    return (
        <div className={`table-responsive`}>
            <div className={`d-flex`} style={{ marginBottom: "5px" }}>
                <select onChange={viewPageChange} value={viewPage}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={70}>70</option>
                    <option value={100}>100</option>
                </select>
            </div>
            <table>
                <colgroup>
                    <col width="50px" />
                    <col width="250px" style={{ minWidth: "250px" }}/>
                    <col width="200px" style={{ minWidth: "200px" }}/>
                    <col />
                    <col width="150px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>No</th>
                        <th>User(ID)</th>
                        <th>Action</th>
                        <th>Desc</th>
                        <th>Date</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={5}>
                                <div style={{ width: "100%", height: "200px", position: "relative" }}>
                                    <LoadingIndicatorBox />
                                </div>
                            </td>
                        </tr>
                    ) : (
                        renderDataList
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan="5">
                            <Pagination data={dataList?.pager} set={(pager) => setDataList((OLD) => ({ ...OLD, pager }))} />
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    );
};

export default forwardRef(Table);
